"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getZapState = (flow) => {
    if (!flow.paused) {
        return 'on';
    }
    if (flow.paused && flow.state === 'on') {
        return 'off';
    }
    return flow.state;
};
exports.default = getZapState;
